import React, { useState } from "react";
import { oneOfType, string, number, func } from "prop-types";
import './styles.scss';

const CellInput = ({ defaultValue, onChange, ...props }) => {
  const [value, setValue] = useState(defaultValue || '');

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <input 
      className="cell-input" 
      value={value} 
      onChange={handleChange}
      {...props} 
    />
  );
};

CellInput.propTypes = {
	defaultValue: oneOfType([ string, number ]),
	onChange: func
};

export default CellInput;
